    import signal from 'signal-js';
    class EventHelper {
        constructor(editor) {
            this.editor = editor;
            this.signal = signal;
        }

        showLoadModel() {
            this.signal.emit("showLoadModel");
        }

    }

    export default EventHelper